import type { AccountFeatureFlag } from '@/services/auth/feature-flags';
import { useFeatureFlag } from '@/services/auth/feature-flags';
import { renderGuardFallback, type GuardFallback } from './guard-fallback';

/**
 * Renders children only when the given feature flag is enabled. Falls back to the given
 * {@link GuardFallback}, or renders nothing by default. Subscribes to the account store, so guarded
 * content reacts to flag changes within a session (e.g. after a cross-app auth refresh).
 */

type FeatureFlagGuardProps = {
  flag: AccountFeatureFlag;
  fallback?: GuardFallback;
  children: React.ReactNode;
};

export function FeatureFlagGuard({ flag, fallback, children }: FeatureFlagGuardProps) {
  const isEnabled = useFeatureFlag(flag);

  if (isEnabled !== true) {
    return <>{renderGuardFallback(fallback)}</>;
  }

  return <>{children}</>;
}
